import routerLocaleInfoData from '@pylot/next-i18next.router-locale-info'

export const defaultCountry = process.env.NEXT_PUBLIC_DEFAULT_COUNTRY || 'US'

export type RouterLocaleInfoType = {
    [p: string]: {
        storeCode: string
        locale: string
        countryCode: string
        storeLabel: string
    }
}

let routerLocaleInfo: undefined | false | RouterLocaleInfoType
export const getRouterLocaleInfo = ():
    undefined | false | RouterLocaleInfoType => {
    if (typeof routerLocaleInfo !== 'undefined') {
        return routerLocaleInfo
    }

    routerLocaleInfo = routerLocaleInfoData as unknown as RouterLocaleInfoType

    return routerLocaleInfo
}
